import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { Modal, Row, Col } from 'react-bootstrap';
import Alert from 'components/ui/Alert';
import { sluggify } from 'utils/localization/utils';
import { checkEquipmentExists } from 'utils/EquipmentWebAPIUtils';
import AddEquipmentForm from '../equipment/AddEquipmentForm';
import EquipmentSearch from './equipments/EquipmentSearch';
class AddEquipmentModal extends Component {
    constructor(props) {
        super(props);
        this.handleClose = () => this.props.onClose();
        this.handleAddEquipment = () => this.setState({ addEquipmentFormVisible: true });
        this.handleCancelAddEquipment = () => this.setState({ addEquipmentFormVisible: false });
        this.handleCreateEquipment = async (equipment) => {
            try {
                const { entity: equipmentData } = await checkEquipmentExists(equipment);
                if (equipmentData.exists === true) {
                    this.setState({ addNewEquipmentError: 'EQUIPMENT_ALREADY_EXIST' });
                }
                if (equipmentData.exists === false) {
                    this.setState({ addNewEquipmentError: null, addEquipmentFormVisible: false }, () => this.props.onCreateEquipment(equipment));
                }
            }
            catch (e) {
                if (sluggify(e.entity.message) === 'EQUIPMENT_MISMATCH') {
                    this.setState({ addNewEquipmentError: 'MISMATCHED_EQUIPMENT_TYPE' });
                }
            }
        };
        this.state = {
            addEquipmentFormVisible: false,
            addNewEquipmentError: null,
        };
    }
    render() {
        const { show, onEquipmentSelect, orderEquipment, t } = this.props;
        const { addNewEquipmentError } = this.state;
        return (React.createElement(Modal, { show: show, enforceFocus: false },
            React.createElement(Modal.Header, null,
                React.createElement(Modal.Title, null, t('ADD_EQUIPMENT_ORDER'))),
            React.createElement(Modal.Body, null,
                React.createElement("h4", { className: "text-grey-dark mb-4" }, titleize(t('EQUIPMENT'))),
                React.createElement("fieldset", { className: "mb-4" },
                    React.createElement("label", { className: "field-label mb-2 w-full" }, t('ENTER_EQUIPMENT_TO_ADD')),
                    React.createElement("div", { className: "equipment-search-wrapper" },
                        React.createElement(EquipmentSearch, { onEquipmentSelect: onEquipmentSelect, orderEquipment: orderEquipment }))),
                React.createElement("div", { className: "separator mb-4" },
                    React.createElement("div", { className: "separator-text" },
                        React.createElement("div", { className: "separator-circle" }, t('OR')))),
                this.state.addEquipmentFormVisible && (React.createElement("div", { className: "bg-grey-lightest my-4 p-4" },
                    addNewEquipmentError && (React.createElement(Alert, { title: t('ERRORS'), type: "error" },
                        React.createElement("ul", null,
                            React.createElement("li", { key: 1 }, t(addNewEquipmentError))))),
                    React.createElement(AddEquipmentForm, { onSave: this.handleCreateEquipment, onCancel: this.handleCancelAddEquipment }))),
                !this.state.addEquipmentFormVisible && (React.createElement("button", { className: "button button-hollow-green", onClick: this.handleAddEquipment },
                    React.createElement("i", { className: "fa fa-plus" }),
                    React.createElement("span", null, t('ADD_NEW_EQUIPMENT'))))),
            React.createElement(Modal.Footer, null,
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 9, sm: 10 }),
                    React.createElement(Col, { xs: 3, sm: 2 },
                        React.createElement("button", { className: "button bg-white text-grey hover:text-grey-dark", onClick: this.handleClose }, titleize(t('CLOSE'))))))));
    }
}
AddEquipmentModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    orderEquipment: PropTypes.array,
    onCreateEquipment: PropTypes.func.isRequired,
    onEquipmentSelect: PropTypes.func.isRequired,
};
export default withTranslation()(AddEquipmentModal);
